export default "__VITE_ASSET__Bf1Wo6L2__"